export const defaultFamilyMedicalData = [
  { id: 'fm1', condition: 'Type 2 Diabetes', familyMember: 'Father', relationType: 'Paternal' },
  { id: 'fm2', condition: 'Breast Cancer', familyMember: 'Grandmother', relationType: 'Maternal' },
  { id: 'fm3', condition: 'cc', familyMember: 'Father', relationType: 'Both' },
];

export const relationTypeOptions = ['Paternal', 'Maternal', 'Both'];
